import React from 'react';
import PropTypes from 'prop-types';

import { registerDecoration } from 'core/forms';

import { FormField } from 'uikit/forms';
import FormFieldText from 'uikit/forms/components/formFieldText';

const FormDecorationDisabled = ({ fieldId = '', schema = {} }) => (
  <FormField
    fieldId={fieldId}
    isRequired={schema.validators?.some(({ type }) => type === 'isRequired')}
    label={schema.label}
    schema={{}}
    type="Decoration"
  >
    <FormFieldText
      fieldId={fieldId}
      onUpdateField={() => {}}
      schema={{ isDisabled: true, placeholder: schema.text }}
    />
  </FormField>
);

FormDecorationDisabled.propTypes = {
  fieldId: PropTypes.string,
  schema: PropTypes.shape({
    label: PropTypes.string,
    text: PropTypes.string,
    validators: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string })),
  }),
};

registerDecoration('Disabled', FormDecorationDisabled);

export default FormDecorationDisabled;
